module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0010.jpg?v=e05e9239";